import CloseIcon from 'components/icons/CloseIcon';
import React from 'react';
import { toast as hotToast } from 'react-hot-toast';
import { v4 } from 'uuid';

const CSS = require('./Toast.module.less');

interface ToastProps {
  text: string;
  icon?: JSX.Element | string | null;
  toastId?: string;
  position?: 'top-center' | 'bottom-center';
}

const toast = ({
  text,
  icon = null,
  toastId = v4(),
  position = 'bottom-center',
}: ToastProps) => {
  hotToast.custom(
    (t) => (
      <div className={CSS.ToastWrapper}>
        <div className={CSS.Icon}>{icon}</div>
        <div className={CSS.Text}>{text}</div>
        <button
          className={CSS.CloseButton}
          onClick={() => hotToast.dismiss(t.id)}
        >
          <CloseIcon width={8} height={8} />
        </button>
      </div>
    ),
    {
      id: toastId,
      position,
    },
  );
};

export default toast;
